
/* injects from baggage-loader */
require('./style.scss');

import React, { Component, Fragment } from "react";
import { Link } from "react-router";
import { getSwarmSubscriptionRequestFavoriteCompetitions } from "../../../helpers/terminalRequests/favoriteCompetitions";
import { getSwarmDataKeyForRequest, SwarmDataMixin } from "../../../mixins/swarmDataMixin";
import { connect } from "react-redux";
import { getFavoriteCompetitionsSubscriptionData } from '../../../helpers/favoriteCompetitionHelpers';
import Loader from "../loader";
import PropTypes from "prop-types";
import Config from "../../../config/main";
import FavoriteSlider from "../favoriteSlider";
import Slider from "react-slick";
import CustomSlider from "../sliderContainer";

class FavoriteCompetitionsSlider extends Component {
    render() {
        let { data } = this.props;
        const settings = {
            dots: true,
            infinite: true,
            speed: 500,
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: false,
            autoplay: true,
            autoplaySpeed: 3000
        };

        return data ? (<Fragment>
            {Config.homePageHorseRacing && <Link to={`/horseRacing`} className="horseRacing">
                <p>
                    <span>
                        <b className={`flag-view-m icon-ireland`} />Ireland
                    </span>
                    <i>Irish Stallion Farms EBF Maiden</i>
                </p>
            </Link>}
            <div className="slide-wrap">
                <div className='container'>
                    {Config.enableHomeImageSlider ? <CustomSlider /> : <Slider {...settings}>
                        {data.map((comp, index) => index >= 5 && <div><FavoriteSlider data={comp} /> </div>)}
                    </Slider>}
                </div>
                <div className="fff">
                    <div className='competitions-list-h'>
                        {
                            data.sort((a, b) => a.favorite_order - b.favorite_order)
                                .map((comp, index) => index < 4 && <Link to={`/prematch/${comp.sportAlias}/${comp.regionId}/${comp.id}`} className={`${comp.regionAlias.toLowerCase()} competition-id-${comp.id}`}>
                                    <p>
                                <span>
                                    <b className={`flag-view-m icon-${comp.regionAlias.toLowerCase().replace(/\s/g, '')}`} />{comp.regionName}
                                </span>
                                        <i>{comp.name}</i>
                                    </p>
                                </Link>)
                        }
                    </div>
                </div>
            </div>
        </Fragment>)
            : <Loader />;
    }
}

FavoriteCompetitionsSlider.propTypes = {
    data: PropTypes.array
};

const mapStateToProps = () => {
    let selectorKey = getSwarmDataKeyForRequest(getSwarmSubscriptionRequestFavoriteCompetitions());
    return getFavoriteCompetitionsSubscriptionData(selectorKey);
};

export default connect(mapStateToProps)(SwarmDataMixin(
    {
        Component: FavoriteCompetitionsSlider,
        ComponentWillMount: function () {
            this.swarmSubscriptionRequest = getSwarmSubscriptionRequestFavoriteCompetitions();
            this.swarmDataKey = getSwarmDataKeyForRequest(getSwarmSubscriptionRequestFavoriteCompetitions());
            this.keepDataAfterUnsubscribe = true;
        }
    }
));